import React from 'react'
import { connect } from 'react-redux';
import styles from './DiaryEntry.module.css'
import { getTimeShort, getDateMDYYYY } from '_helpers';
import { DiaryTaskIcon } from '_components';

class PatientHomeDiaryEntry extends React.Component {

    render() {
        var bold = this.props.entry.status >= 1 && this.props.entry.status <= 3 ? styles.bold : '';
        return (
            <div className={styles.entry_wrapper + ' ' + bold}>
                <div className={styles.spacer}><DiaryTaskIcon size='extra-small' status={this.props.entry.status} title={this.props.entry.tooltip}/></div>
                <div className={styles.date}>{getDateMDYYYY(this.props.entry.diaryDate)}</div>
                <div className={styles.time}>{getTimeShort(this.props.entry.diaryDate)}</div>
                <div className={styles.user}>{this.props.entry.user}</div>
                <div className={styles.entry} title={this.props.entry.category + ': ' + this.props.entry.note}>{this.props.entry.note}</div>
            </div>
        );
    }
}

function mapStateToProps(state, ownprops) {
    return {
        entry: state.entities.diary[ownprops.id]
    };
}

const connectedPatientHomeDiaryEntry = connect(mapStateToProps)(PatientHomeDiaryEntry);
export { connectedPatientHomeDiaryEntry as PatientHomeDiaryEntry };